"use client";

import { useState, useEffect } from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Legacy() {
  const [isZh, setIsZh] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsZh(localStorage.getItem("elite-language") === "zh-Hant");
    }
  }, []);
  const {
    ref: portraitRef,
    isVisible: portraitVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const paragraphsEn = ["Elite Group Corporation Limited was founded on the principle that manufacturing is an act of precision engineering. From our origins in Hong Kong, we have evolved into a comprehensive OEM/ODM partner, bridging the gap between creative toy concepts and industrial-scale production. Our journey is defined by a commitment to technical excellence and the rigorous standards required by global markets.", "Our operational model is built on total control. By owning and managing two specialized production facilities in China—one dedicated to plastic injection and the other to plush manufacturing—we ensure that every unit meets our exacting quality benchmarks. This vertical integration allows us to maintain transparency, efficiency, and consistency across every production run.", "Compliance is the cornerstone of our reputation. We navigate the complexities of international safety standards by partnering with world-class testing laboratories including BV, ITS, SGS, and TUV. Whether securing CCC certification for the Chinese market or G-Mark for the Gulf States, our team manages the regulatory landscape so our clients can focus on innovation.", "We believe that true manufacturing success is measured by the longevity of our partnerships. By providing a one-stop service from initial R&D to final delivery, we act as an extension of your brand, ensuring that every product we manufacture reflects the quality and integrity of your vision."];
  const paragraphsZh = ["Elite Group Corporation Limited 創立於對製造即精密工程的堅持。從立足香港起步，我們已發展為全方位的 OEM/ODM 合作夥伴，在創意玩具概念與工業化規模生產之間架起橋樑。我們的歷程展現了對卓越技術的執著追求，以及對全球市場嚴格標準的堅守。", "我們的運營模式建基於全面把控。通過全資擁有並管理在中國的兩家專業生產基地——一家專注塑膠注塑，另一家專注毛絨玩具製造——我們確保每一件產品均符合嚴格的品質基準。這種垂直整合模式使我們在每次生產週期中都能保持高透明度、高效能與一致性。", "合規性是我們商譽的基石。我們與 BV、ITS、SGS 和 TUV 等世界頂級檢測實驗室合作，應對國際安全標準的複雜要求。無論是為中國市場取得 CCC 認證，還是為海灣國家取得 G-Mark 認證，我們的專業團隊都能妥善管理法規要求，讓客戶專注於產品創新。", "我們堅信，製造業的真正成功取決於合作關係的持久長遠。通過提供從早期研發到最終交付的一站式服務，我們成為您品牌值得信賴的延伸，確保我們製造的每一款產品都能體現您對品質與誠信的追求。"];
  const paragraphs = isZh ? paragraphsZh : paragraphsEn;
  return <section data-section-id="16836" id="the-elite-legacy" className="bg-background text-foreground py-32 md:py-44 lg:py-56">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-0">
          

          <div className="lg:col-span-7 lg:pl-24">
            <div ref={textRef} className="transition-all duration-[700ms]" style={{
            opacity: textVisible ? 1 : 0,
            transform: textVisible ? "translateY(0)" : "translateY(8px)",
            transitionDelay: textVisible ? "80ms" : "0ms",
            transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
          }}>
              <p className="font-default italic text-base leading-[1.4]" style={{
              color: "var(--muted-foreground)"
            }}>
                {isZh ? "我們的傳承" : "Our Heritage"}
              </p>

              <h1 className="font-default font-bold text-foreground mt-6" style={{
              fontSize: "clamp(2.75rem, 6.4vw, 5.75rem)",
              letterSpacing: "-0.025em",
              lineHeight: 1.02
            }}>
                {isZh ? <>
                    精準
                    <span className="font-default italic font-normal" style={{
                  letterSpacing: "-0.015em"
                }}>
                      製造
                    </span>
                  </> : <>
                    Precision in{" "}
                    <span className="font-default italic font-normal" style={{
                  letterSpacing: "-0.015em"
                }}>
                      manufacturing
                    </span>
                  </>}
              </h1>

              <div className="mt-14 space-y-6">
                {paragraphs.map((paragraph, i) => <p key={i} data-index={i} className="font-default text-foreground" style={{
                fontSize: "1.0625rem",
                lineHeight: 1.65,
                maxWidth: "56ch",
                letterSpacing: 0
              }}>
                    {i === 0 ? <>
                        <span className="font-default italic float-left mr-2 leading-[0.9]" style={{
                    fontSize: "clamp(3.5rem, 5vw, 4.5rem)",
                    color: "var(--primary)",
                    marginTop: "0.1em"
                  }}>
                          {paragraph.charAt(0)}
                        </span>
                        {paragraph.slice(1)}
                      </> : paragraph}
                  </p>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}